// extracted by mini-css-extract-plugin
module.exports = {"main-logo":"Home_main-logo__3ELWP","develop-portal":"Home_develop-portal__3vHO9","text-center":"Home_text-center__1AyQ2"};